export default "__VITE_ASSET__DMySmsjC__"